export let super_config = [
	{
		collapse: true,
		/*tabs: true,*/
		elements: []
	},
	{
		blockTitle: 'Первая вкладка коллапса',
		icon: 'tim-icons icon-single-02',
		elements: [
			{
				elementGetParamMap: 'test_ReContactMessangersTemplate',
				elementType: 'contact-drawer',
				label: 'Рисовалка контактов',
				text: 'Многа текста Многа текста Многа текста Многа текста Многа текста Многа текста Многа текста Многа текста',
				contacts: [
					{"contact_id":65,"contact_group":"phone","contact_type":"1","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"},
					{"contact_id":727,"contact_group":"messanger","contact_type":"40","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"},
					{"contact_id":728,"contact_group":"messanger","contact_type":"41","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"},
					{"contact_id":1106,"contact_group":"messanger","contact_type":"42","contact_value":"+7 921 323-67-00","contact_view":0,"code":32,"contact_src_value":"","concact_phone_INT":"79213236700"}
				],
				masCalls: [],
			},
			
			{
				elementGetParamMap: 'test_textarea_popover',
				element_model: '',
				elementType: 'textarea-popover',
				placeholder: 'Описание темы',
				label: 'Описание темы test_textarea_popover',
				pop_content: 'Текст для поповера Текст для поповера Текст для поповераТекст для поповера Текст для поповера',
				// reference: '<p> Текст для поповера <br> Текст для поповера Текст для поповераТекст для поповера Текст для поповера </p>',
				// popper_class: 'popsss',
				pop_title: 'Текст для титла поповера',
			},
			{
				elementGetParamMap: 'test_rating',
				element_model: 0,
				elementType: 'rating',
				label: 'Оцените работу исполнителя'
			},
			{
				elementGetParamMap: 'test_square-cost',
				element_model: [{square:"",price:"",}],
				elementType: 'square-cost',
				placeholder: '',
				label: 'Стоимость за площадь части',
			},
			{
				elementGetParamMap: 'test_distrmetro',
				elementType: 'input-ajaxsearch-distrmetro',
				element_model: {'district_ids':{value:'', tagText:'Район', catalog:'CAT_DIST_TR', options:[]},'metro_ids':{value:'', tagText:'Метро',catalog:'CAT_METRO', options:[]}},
				label: 'Район и метро',
				placeholder:'Поиск по метро, району',
				required: false,
			},
			{
				elementGetParamMap: 'test_label',
				element_model: 'Вывожу, только вывод',
				elementType: 'label',
				placeholder: 'Лабел'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'Пиши в меня',
				label: 'Инпут'
			},
			{
				elementGetParamMap: 'test_input_mask',
				element_model: '',
				elementType: 'input-mask',
				placeholder: 'Пиши в меня',
				label: 'Инпут mask money',
				mask: 'money'
			},
			{
				elementGetParamMap: 'test_input_mask_phone',
				element_model: '',
				elementType: 'input-mask',
				placeholder: 'Пиши в меня',
				label: 'Инпут mask phone',
				mask: 'phone'
			},
			{
				elementGetParamMap: 'test_input_number',
				element_model: '',
				elementType: 'input-number',
				placeholder: 'Пиши в меня',
				label: 'Числовой инпут'
			},
			{
				elementGetParamMap: 'test_input-hidden',
				element_model: 'Меня не видно, но я есть',
				elementType: 'input-hidden',
			},
			{
				elementGetParamMap: 'test_radio-group',
				element_model: '2',
				elementType: 'radio-group',
				label: 'Группа переключателей',
				options: [{name: '1', label: 'Да',},{name: '0', label: 'Нет',},{name: '2', label: 'Может быть',}]
			},
			{
				elementGetParamMap:"uData",
				elementCat:"CONTACTS_TYPES",
				element_model:[
					{contact_id:"",contact_type:"",contact_value:"",contact_view:"",contact_group:"phone", contact_foreign: false}
				],
				elementType:"input-contact",
				delMethod:{apiMethod:"DEL_CONTACT",apiParam:{obj:"staff",flt:{code:"",contact_id:""}}},
				label:"Телефон",
				placeholder:"Введите номер",
				contactGroup:"phone",
				contactGroup_options:[
					{value:"1",label:"Телефон моб."},
					{value:"2",label:"Телефон раб."}
				]
			},
			{
				elementGetParamMap: 'test_select',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: '',
				label: 'Селект',
				placeholder: 'Нажми для выбора',
				options:[
					{value: '1', label: 'Да',},
					{value: '2', label: 'Нет',},
					{value: '3', label: 'Может быть',},
				],
				canSkip: true,
				canSkip_model: false,
				canSkip_label: 'обязательно - не обязательно',
				required: true
			},
			{
				elementGetParamMap: 'test_filter_select',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: '',
				label: 'Селект фильтруемый',
				placeholder: 'Пиши во мне',
				filterable: true,
				options:[
					{value: '1', label: 'Да',},
					{value: '2', label: 'Нет',},
					{value: '3', label: 'Может быть',},
				]
			},
			{
				elementGetParamMap: 'test_multi_select',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: [],
				label: 'Селект мульти выбор',
				placeholder: 'Нажми для выбора',
				multiple: true,
				options:[
					{value: '1', label: 'Да',},
					{value: '2', label: 'Нет',},
					{value: '3', label: 'Может быть',},
				]
			},
			{
				elementGetParamMap: 'test_multi_filter_select',
				elementCat: 'cat_position',
				elementType: 'select',
				element_model: [],
				label: 'Селект мульти фильтр',
				placeholder: 'Пиши во мне',
				filterable: true,
				multiple: true,
				options:[
					{value: '1', label: 'Да',},
					{value: '2', label: 'Нет',},
					{value: '3', label: 'Может быть',},
				]
			},
			{
				elementGetParamMap: 'test_select-tree',
				elementType: 'select-tree',
				element_model: {inputText:'', selectedVal:''},
				label: 'Селект дерево',
				placeholder: 'Пиши во мне',
			},
			{
				elementGetParamMap: 'test_input-date',
				elementType: 'input-date',
				element_model: '',
				label: 'Дата',
				placeholder: 'Нажми для выбора',
				defaultvalue:'' //defaultvalue:'1990-01-01' -- если надо проставить дефолтное значение
			},
			{
				elementGetParamMap: 'sds|sde',
				elementType: 'input-date-range',
				element_model: {startDt:'',endDt:''},
				label: 'Диапазон дат',
				range_separator: '-',
				start_placeholder: 'Дата с',
				end_placeholder: 'Дата по',
			},
			{
				elementGetParamMap: 'test_input-datetime',
				elementType: 'input-datetime',
				element_model: '',
				label: 'Дата и время',
				placeholder: 'Нажми для выбора',
			},
			{
				elementGetParamMap: 'test_input-time',
				elementType: 'input-time',
				element_model: '',
				label: 'Время',
				placeholder: 'Нажми для выбора',
			},
			{
				elementGetParamMap: 'sts|ste',
				elementType: 'input-time-range',
				element_model: {startDt:'',endDt:''},
				label: 'Диапазон время',
				range_separator: '-',
				start_placeholder: 'Время с',
				end_placeholder: 'Время по',
			},
			{
				elementGetParamMap: 'vm_fst|vm_snd|vm_trd',
				elementType: 'checkbox-group',
				element_model: {vm_fst:false,vm_snd:true,vm_trd:false},
				label: 'Группа галочек',
				options:[
					{key:'vm_fst',label:'первый'},
					{key:'vm_snd',label:'второй'},
					{key:'vm_trd',label:'я дизаблен',disabled:true},
				]
			},
			{
				elementGetParamMap: 'test_checkbox',
				elementType: 'checkbox',
				element_model: false,
				placeholder: 'Галочка',
				label: 'нажми меня',
			},
			{
				elementGetParamMap: 'test_switcher',
				elementType: 'switcher',
				element_model: false,
				placeholder: 'Переключатель',
				label_on: 'Да',
				label_off: 'Нет',
			},
			{
				elementGetParamMap: 'test_list',
				elementType: 'list',
				element_model: {},
				label: 'Список только вывод',
			},
			{
				elementGetParamMap: 'test_task_ends',
				elementType: 'task-ends',
				element_model: [],
				label: 'Список результатов выполнения задач',
			},
			{
				elementGetParamMap: 'test_ajax_list',
				elementType: 'ajax-list',
				element_model: {},
				label: 'Выпадающий список с поиском',
				placeholder:"Выбрать сотрудников",
				objApiMethod:{'obj':'staff' ,'flt':{'fio':''}},
				strApiMethodKey:"fio",
			},
			{
				elementGetParamMap: 'test_ajax_list_tags',
				elementType: 'ajax-list-tags',
				element_model: [],
				label: 'Выпадающий список с поиском и тэгами',
				placeholder:"Выбрать сотрудников",
				objApiMethod:{'obj':'staff' ,'flt':{'fio':''}},
				strApiMethodKey:"fio",
			},
			{
				elementGetParamMap:'photo',
				element_model:'/img/placeholder.jpg',
				elementType:'file-upload',
				label:'Загрузить изображение',
				type: 'avatar',
				multiple: false,
				acceptMime: 'image/*',
				uploadApi: {},
				delApi: {},
			},
			{
				elementGetParamMap:'files_multi',
				element_model:'/img/uploadicon.jpg',
				elementType:'file-upload',
				formId: 'MULTIPLEUPLOAD_01',
				label:'Загрузить много',
				type: 'file',
				multiple: true,
				acceptMime: '*/*',
				uploadApi: {apiMethod:'UniUpload',apiParam:{obj:'FileUpload',flt:{type:'taskend_file'}}},
				delApi: {},
			},
			{
				elementGetParamMap: 'test_fromMetro',
				elementType: 'fromMetro',
				element_model: {},
				label: 'Расстояние до метро',
				placeholder:'км',
				required: false,
				options:[
					{name:'1',label:'Пешком'},
					{name:'2',label:'Транспортом'},
				]
			},
			{
				elementGetParamMap: 'test_urgency',
				elementType: 'urgency',
				element_model: {},
				label: 'Срочность',
				required: false,
				options_buy:[
					{value:1,label:'Сейчас'},
					{value:2,label:'1 месяц'},
					{value:3,label:'3 месяца'},
					{value:4,label:'6 месяцев'},
					{value:5,label:'Более года'},
				],
				options_keys:[
					{value:1,label:'Любой срок?'},
					{value:2,label:'До 1 квартала 2020'},
					{value:3,label:'До 2 квартала 2020'},
					{value:4,label:'До 3 квартала 2020'},
					{value:5,label:'До 4 квартала 2020'},
					{value:6,label:'До 1 квартала 2021'},
					{value:7,label:'До 2 квартала 2021'},
					{value:8,label:'До 3 квартала 2021'},
					{value:9,label:'До 4 квартала 2021'},
					{value:10,label:'До 1 квартала 2022'},
					{value:11,label:'До 2 квартала 2022'},
					{value:12,label:'До 3 квартала 2022'},
					{value:13,label:'До 4 квартала 2022'},
				],
			},
			{
				elementGetParamMap: 'test_scheduleServices',
				elementType: 'select-scheduleServices',
				element_model_default: {'rb_service':'1','bp_id':'','status':'','days':''},
				element_model: {'rb_service':'1','bp_id':'','status':'','days':''},
				label: 'Услуга по расписанию',
			},
		]
	},
	{
		blockTitle: 'Вторая вкладка коллапса',
		icon: 'tim-icons icon-email-85',
		elements: [
			{
				elementGetParamMap: 'test_label',
				element_model: 'Вывожу, только вывод',
				elementType: 'label',
				placeholder: 'Лабел'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'Пиши в меня',
				label: 'Инпут'
			},
			{
				elementGetParamMap: 'HELP',
				element_model: '',
				elementType: 'HELP',
			}
		]
	},
];
